export default {
    isDev: () => {
        return document.location.href.indexOf(':3000') !== -1 || document.location.href.indexOf(':8000') !== -1;
    }
};
